let headers = [];

export class HeaderDisclosures {
    constructor(header) {
        this.header = header;
        this.body = this.header.nextSibling;
        this.button = this.addDisclosureButton();

        this.init();
    }

    init = () => {
        this.button.addEventListener('click', this.clickHandler);
    }

    open = () => {
        this.button.setAttribute('aria-expanded', 'true');
        this.isOpened = true;
    }
    
    close = () => {
        this.button.setAttribute('aria-expanded', 'false');
        this.isOpened = false;
    }

    clickHandler = (e) => {
        e.preventDefault();

        if (this.isOpened) {
            this.close();
        } else {
            this.open();
        }
    }

    addDisclosureButton = () => {
        const chevron = `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="jwc-header-disclosure-icon">
                <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
            </svg>
        `;

        const button = document.createElement('button');
        button.setAttribute('aria-expanded', 'false');
        button.classList.add('jwc-header-disclosure');

        button.innerHTML = `
            ${this.header.innerHTML}
            ${chevron}
        `;

        this.header.parentNode.insertBefore(button, this.header.nextSibling);

        return button;
    }
}

export default init = (target = document) => {
    const targetElements = [...target.querySelectorAll('[data-header-disclosure]')];
    const dedupedHeaders = headers.filter(header => !targetElements.find(element => element === header));

    headers = [...dedupedHeaders, ...targetElements];

    if (headers.length === 0) return;

    headers.forEach(header => new HeaderDisclosures(header));
}